<template>
  <div :key="`scenarioend-menu-${endId}`">
    <item-header type="scenarioEnd" @close="$emit('close')">
      <template #content>
        <editable-item-title :item="end" />
      </template>
    </item-header>

    <drawer-block :title="$t('objectNames.condition', 20)" :open="true">
      <condition-list
        :src-type="'scenarioEnd'"
        :src-id="endId"
        :selected-condition="subSelection || undefined"
        @select="emit('select', $event)"
      />
    </drawer-block>

    <drawer-block :title="$t('labels.general')" :open="true">
      <div class="column gap-4">
        <input-text
          :value="end.title"
          :label="$t('labels.title')"
          @update:value="update({ title: $event })"
        />

        <input-texteditor
          :value="end.description"
          :label="$t('labels.description')"
          @update:value="update({ description: $event })"
        />
      </div>
    </drawer-block>

    <drawer-block :title="$t('labels.design')">
      <input-image
        :id="end.imageId"
        :max-width="1000"
        :max-height="1000"
        :compression="0.9"
        :control-object-fit="true"
        :target-width="325"
        :target-height="520"
        @update="setImage"
        @delete="deleteImage"
      />
    </drawer-block>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import InputText from "@core/input/InputText.vue";
import InputTexteditor from "@core/input/TextEditor.vue";
import InputImage from "@editor/items/image/InputImage.vue";
import ItemHeader from "@editor/components/ItemHeader.vue";
import EditableItemTitle from "@editor/components/EditableItemTitle.vue";

import ConditionList from "../condition/ConditionList.vue";

import { useScenarioEndStore } from "@editor/items/scenarioEnd/scenarioEnds.store";
import DrawerBlock from "@core/ui/DrawerBlock.vue";

const props = defineProps<{
  endId: number;
  subSelection: { type: "condition"; id: number } | null;
}>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "select", item: { type: "condition"; id: number }): void;
}>();

const end = computed(() => {
  return useScenarioEndStore().items[props.endId];
});

function update(data = {}) {
  useScenarioEndStore().update({
    id: props.endId,
    ...data
  });
}
function setImage(image: { id: number }) {
  update({ imageId: image.id });
}
function deleteImage() {
  update({ imageId: null });
}
</script>

<style></style>
